import React, { createContext, useContext, useEffect } from 'react'
import { initializeApm, getApmInstance } from './init.ts'
import { ApmConfig } from './types'
import { APM_SERVICE_NAME, APM_URL } from './constants.ts'
import { SourceUrlStorage } from '@monorepo/utils'

const ApmContext = createContext<ReturnType<typeof getApmInstance>>(null)

interface ApmProviderProps {
  children: React.ReactNode
  overrideConfig?: Partial<ApmConfig>
}

export const ApmProvider: React.FC<ApmProviderProps> = ({ children, overrideConfig = {} }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') SourceUrlStorage.set(window.location.href)
  }, [])

  useEffect(() => {
    const config: ApmConfig = {
      serverUrl: APM_URL || '',
      serviceName: APM_SERVICE_NAME,
      ...overrideConfig,
    }

    if (!config.serviceName || !config.serverUrl) {
      console.warn('Elastic APM not initialized - missing required env variables')
      return
    }

    initializeApm(config)
  }, [overrideConfig])

  return <ApmContext.Provider value={getApmInstance()}>{children}</ApmContext.Provider>
}

export const useApm = () => useContext(ApmContext)
